import { render, staticRenderFns } from "./TempRegApproval.vue?vue&type=template&id=aedaf7c4&scoped=true"
import script from "./TempRegApproval.vue?vue&type=script&lang=js"
export * from "./TempRegApproval.vue?vue&type=script&lang=js"
import style0 from "./TempRegApproval.vue?vue&type=style&index=0&id=aedaf7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedaf7c4",
  null
  
)

export default component.exports